import { useQuery } from "@tanstack/react-query";
import ReportIncidenService from "../../../components/api/ReportIncidenService";

export const getDsrDeadlineHistoryQueryKey = (caseId) => [
  "dsr-deadline-history",
  caseId,
];

export const useDsrDeadlineHistory = (caseId, enabled) =>
  useQuery({
    queryKey: getDsrDeadlineHistoryQueryKey(caseId),
    queryFn: async () => {
      const service = ReportIncidenService.getInstance();
      return await service.fetchAwaitingRequesterHistory(caseId);
    },
    enabled: enabled && !!caseId,
    cacheTime: 0,
    refetchOnWindowFocus: false,
  });
